// tslint:disable-next-line:import-blacklist
import { MicroviewMetadata } from '@tableau/microview/lib/src/MicroviewMetadata';

export const omniboxMetadata: MicroviewMetadata = {
  name: 'omnibox-microview',
  distFolderName: 'omnibox',
};
